import React, { useEffect, useMemo, useState, type ReactNode } from 'react';
import { useLocation } from 'react-router';

import SettingsContext from './context';
import { useBaseCurrency } from '../../hooks/useBaseCurrency';
import useBreadcrumbs from '../../views/base/Breadcrumbs/hooks';

import { useUserContext } from '../user';
import { useAnalyticsContext } from '../analytics';

import { useDebouncedEffect } from '../../hooks/useDebouncedEffect';
import { getHolidays } from '../../services/StrategicOverview';
interface SettingsContextProviderProps {
  children: ReactNode;
}

const SettingsContextProvider = ({ children }: SettingsContextProviderProps) => {
  const { userIsLogged, userSession } = useUserContext();
  const { mixPanel: { trackPageEvent } } = useAnalyticsContext();
  const currency = useBaseCurrency();
  const location = useLocation();

  const [holidaysList, setHolidaysList] = useState([]);

  const {
    defaultItems: defaultBreadcrumbsItems, breadcrumbsItems, setBreadcrumbsItems,
  } = useBreadcrumbs();

  useDebouncedEffect(() => {
    const init = async () => {
      try {
        const holidays = await getHolidays({ country: userSession.country || 'BR' });

        setHolidaysList(holidays || []);
      } catch (_error) {
        // error
      }
    };

    if (userIsLogged()) {
      init();
    }
  }, [userSession.country]);

  useEffect(() => {
    if (userIsLogged()) {
      trackPageEvent(breadcrumbsItems);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const value = useMemo(() => ({
    currency,
    holidaysList,
    breadcrumbs: {
      defaultBreadcrumbsItems,
      breadcrumbsItems,
      setBreadcrumbsItems,
    },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [currency, breadcrumbsItems, holidaysList]);

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
export default SettingsContextProvider;
